/*
 * Spotted In — arrow-controlled scroll carousel.
 * Handles dynamic gap calculation, touch swipe sync, and Shopify theme editor reloads.
 */
(function () {
  'use strict';

  function initSpottedIn() {
    var sections = document.querySelectorAll('.spotted-in');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var track = section.querySelector('#spTrack');
      var prevBtn = section.querySelector('#spPrev');
      var nextBtn = section.querySelector('#spNext');

      if (!track || !prevBtn || !nextBtn) return;

      function getScrollStep() {
        var card = track.querySelector('.spotted-in__card');
        if (!card) return 260;

        var computedStyle = window.getComputedStyle(track);
        var gap = parseFloat(computedStyle.gap) || (window.innerWidth <= 768 ? 12 : 16);
        return card.getBoundingClientRect().width + gap;
      }

      function scrollByCard(direction) {
        var step = getScrollStep();
        track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      // Avoid duplicate listener attachments
      prevBtn.replaceWith(prevBtn.cloneNode(true));
      nextBtn.replaceWith(nextBtn.cloneNode(true));

      var newPrevBtn = section.querySelector('#spPrev');
      var newNextBtn = section.querySelector('#spNext');

      newPrevBtn.addEventListener('click', function () { scrollByCard(-1); });
      newNextBtn.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpottedIn);
  } else {
    initSpottedIn();
  }

  // Support Shopify Theme Editor dynamic block/section updates
  document.addEventListener('shopify:section:load', initSpottedIn);
})();